import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  private modals: any[] = [];

  public add(modal: any) {
    this.remove(modal.id);
    this.modals.push(modal);
    this.modals = [...this.modals];
  }

  remove(id: string) {
    //TODO: use this to remove elements from arrays
    this.modals = this.modals.filter((x) => x.id !== id);
  }

  open(id: string, parameterObject?: any) {
    const modal = this.modals.find((x) => x.id === id);
    if (modal) {
      parameterObject ? modal.open(parameterObject) : modal.open();
    }
  }

  close(id: string) {
    const modal = this.modals.find((x) => x.id === id);
    modal?.close();
  }

  toggle(id: string) {
    const modal = this.modals.find((x) => x.id === id);
    if (modal) {
      if (modal.isOpen) {
        modal.close();
        return;
      }
      modal.open();
    }
  }

  closeAll() {
    this.modals.forEach((m) => {
      if (m.close) {
        m.close();
      }
    });
  }

  clearAll() {
    this.closeAll();
    this.modals = [];
  }
}
